import { removeSavedItems } from "@repo/apis/customers-saveditems-v3";
import { SavedItemsSdkMethod } from "../utils/method-initializer";

type PublicRemoveSavedItemsMethod = (params: {
  itemId: string;
}) => Promise<void>;
type RemoveSavedItemsMethod = SavedItemsSdkMethod<PublicRemoveSavedItemsMethod>;

export const removeSavedItemsInitializer: RemoveSavedItemsMethod =
  ({ getAuthHeader, ...context }) =>
  async ({ itemId }) => {
    try {
      await removeSavedItems({
        itemId,
        chameleonRequestInstance: context.chameleonRequestInstance,
        keyStoreDataversion: context.keyStoreDataversion,
        store: context.store,
        currency: context.currency,
        sizeSchema: context.sizeSchema,
        lang: context.lang,
        authHeader: await getAuthHeader(),
        country: context.country,
        shop: context.shop,
      });
    } catch (error) {
      console.error("Error removing saved items:", error);
      throw error;
    }
  };
